module.exports = __webpack_public_path__ + "static/ig_banner_08-944d7ea518af0f0ff029225d9d00b78d.png";